import { c as _c } from "react/compiler-runtime";
import { Menu } from "@flat-ui";
import { FilterChip } from "@components/common/faro-table/faro-table-filter/filter-chip";
import { FilterChipDropdownList } from "@components/common/faro-table/faro-table-filter/filter-chip-dropdown-list";
import { useFilterQueryParams } from "@hooks/table-filters/use-filter-query-params";
import { Box } from "@mui-wrapper";
import { useState } from "react";
/** A chip to show for grouping set of filters. The children is the content shown after clicking on a chip */
export function DropdownFilterChip(t0) {
  const $ = _c(38);
  const {
    filteredColumn,
    label,
    items,
    shouldShowSearchBox,
    shouldShowCheckbox,
    shouldShowCheckIconOnRight: t1,
    shouldAllowLabelTranslation: t2,
    tableType,
    size: t3,
    isLoading: t4,
    onOpen
  } = t0;
  const shouldShowCheckIconOnRight = t1 === undefined ? false : t1;
  const shouldAllowLabelTranslation = t2 === undefined ? false : t2;
  const size = t3 === undefined ? "small" : t3;
  const isLoading = t4 === undefined ? false : t4;
  const [anchorEl, setAnchorEl] = useState(null);
  const dropdownWidth = size === "small" ? "230px" : "350px";
  const {
    getFilterIdsForColumn,
    updateFilterItem
  } = useFilterQueryParams();
  let t5;
  if ($[0] !== filteredColumn || $[1] !== getFilterIdsForColumn) {
    t5 = getFilterIdsForColumn(filteredColumn);
    $[0] = filteredColumn;
    $[1] = getFilterIdsForColumn;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  const activeFilterIds = t5;
  let t6;
  if ($[3] !== filteredColumn || $[4] !== shouldShowCheckbox || $[5] !== tableType || $[6] !== updateFilterItem) {
    t6 = function onOptionClicked(filterId) {
      updateFilterItem({
        tableType,
        filteredColumn,
        filterId,
        shouldReplaceFilterInColumn: !shouldShowCheckbox
      });
    };
    $[3] = filteredColumn;
    $[4] = shouldShowCheckbox;
    $[5] = tableType;
    $[6] = updateFilterItem;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const onOptionClicked = t6;
  const t7 = !!anchorEl;
  let t8;
  if ($[8] !== onOpen) {
    t8 = event => {
      setAnchorEl(event.currentTarget);
      onOpen?.();
    };
    $[8] = onOpen;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== filteredColumn || $[11] !== label || $[12] !== t7 || $[13] !== t8) {
    t9 = <FilterChip filteredColumn={filteredColumn} label={label} shouldHaveDropdown={true} isDropdownOpen={t7} onClick={t8} />;
    $[10] = filteredColumn;
    $[11] = label;
    $[12] = t7;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  const t10 = !!anchorEl;
  let t11;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = () => setAnchorEl(null);
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== dropdownWidth) {
    t12 = {
      paper: {
        sx: {
          width: dropdownWidth,
          maxHeight: "330px",
          overflowY: "auto"
        }
      }
    };
    $[16] = dropdownWidth;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = () => setAnchorEl(null);
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== activeFilterIds || $[20] !== isLoading || $[21] !== items || $[22] !== label || $[23] !== onOptionClicked || $[24] !== shouldAllowLabelTranslation || $[25] !== shouldShowCheckIconOnRight || $[26] !== shouldShowCheckbox || $[27] !== shouldShowSearchBox) {
    t14 = <FilterChipDropdownList label={label} items={items} activeFilterIds={activeFilterIds} shouldShowSearchBox={shouldShowSearchBox} shouldShowCheckbox={shouldShowCheckbox} shouldShowCheckIconOnRight={shouldShowCheckIconOnRight} shouldAllowLabelTranslation={shouldAllowLabelTranslation} isLoading={isLoading} onItemClicked={onOptionClicked} onEscape={t13} />;
    $[19] = activeFilterIds;
    $[20] = isLoading;
    $[21] = items;
    $[22] = label;
    $[23] = onOptionClicked;
    $[24] = shouldAllowLabelTranslation;
    $[25] = shouldShowCheckIconOnRight;
    $[26] = shouldShowCheckbox;
    $[27] = shouldShowSearchBox;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== anchorEl || $[30] !== dropdownWidth || $[31] !== t10 || $[32] !== t12 || $[33] !== t14) {
    t15 = <Menu anchorEl={anchorEl} open={t10} onClose={t11} minWidth={dropdownWidth} slotProps={t12}>{t14}</Menu>;
    $[29] = anchorEl;
    $[30] = dropdownWidth;
    $[31] = t10;
    $[32] = t12;
    $[33] = t14;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== t15 || $[36] !== t9) {
    t16 = <Box component="div">{t9}{t15}</Box>;
    $[35] = t15;
    $[36] = t9;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  return t16;
}